"use strict";
// shared-types/src/database/__fixtures__/material-attributes.fixtures.ts
//
// Typed_Test_Fixtures — one exhaustive fixture per category and per subcategory,
// each populating EVERY field of its Attribute_Type_Model type with a valid value.
//
// These fixtures are the heart of the Type_Test_Interlock (design §Type_Test_Interlock):
//   - Each fixture is explicitly typed against its model type (no `as any`, no
//     laundering `as`-casts, no `Record<string, unknown>` bags). Any future change
//     to the Attribute_Type_Model breaks the matching fixture at COMPILE TIME.
//   - Exhaustiveness (every field present) is verified at TEST TIME by Property 4
//     (task 1.7), which checks that a fixture's keys cover every field of its
//     (category, subcategory) per `getExpectedAttributes`.
//   - Conformance (field-set + options agreement) is verified by Property 3
//     (task 1.6), which feeds these fixtures through `getExpectedAttributes`.
//
// For option/literal-union fields a real member of that union is used; for `number`
// fields a number; for free-text `string` fields a representative string.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATERIAL_ATTRIBUTE_FIXTURES = exports.toolsBaseFixture = exports.blanksBasesBaseFixture = exports.embellishmentsBaseFixture = exports.storageBaseFixture = exports.kidsCraftsBaseFixture = exports.stuffingDollmakingBaseFixture = exports.floralDecorBaseFixture = exports.woodDiyBaseFixture = exports.clayResinBaseFixture = exports.adhesivesBaseFixture = exports.cuttingMachinesVinylHtvFixture = exports.cuttingMachinesBaseFixture = exports.beadsWireFixture = exports.beadsBaseFixture = exports.artSuppliesBaseFixture = exports.paperBaseFixture = exports.needleArtsBaseFixture = exports.needlesHooksTunisianHooksFixture = exports.needlesHooksCrochetHooksFixture = exports.needlesHooksKnittingInterchangeableFixture = exports.needlesHooksKnittingDpnFixture = exports.needlesHooksKnittingCircularFixture = exports.needlesHooksKnittingStraightFixture = exports.needlesHooksBaseFixture = exports.yarnBaseFixture = exports.sewingNotionsBattingFixture = exports.sewingNotionsStabilizerFixture = exports.sewingNotionsInterfacingFixture = exports.sewingNotionsWidthFixture = exports.sewingNotionsZippersFixture = exports.sewingNotionsNeedlesMachineFixture = exports.sewingNotionsNeedlesHandFixture = exports.sewingNotionsThreadFixture = exports.sewingNotionsBaseFixture = exports.fabricThicknessFixture = exports.fabricBaseFixture = void 0;
// ---------------------------------------------------------------------------
// 1) fabric
// ---------------------------------------------------------------------------
exports.fabricBaseFixture = {
    fiber_content: '100% cotton',
    fabric_type: 'woven',
    care: 'machine wash warm',
    width_value: 44,
    width_unit: 'inches',
    weight: 'medium',
    stretch: 'none',
    pattern_scale: 'solid',
    color: 'navy',
    color_family: 'blue',
    print_or_pattern: 'floral',
};
/** leather / faux_leather / vinyl add `thickness`. */
exports.fabricThicknessFixture = {
    ...exports.fabricBaseFixture,
    thickness: '2 mm',
};
// ---------------------------------------------------------------------------
// 2) sewing_notions
// ---------------------------------------------------------------------------
exports.sewingNotionsBaseFixture = {
    primary_material: 'polyester',
    size: '40wt',
    color: 'white',
    color_family: 'white',
};
exports.sewingNotionsThreadFixture = {
    ...exports.sewingNotionsBaseFixture,
    thread_type: 'all_purpose',
    thread_weight: '40wt',
};
exports.sewingNotionsNeedlesHandFixture = {
    ...exports.sewingNotionsBaseFixture,
    needle_type: 'sharps',
    needle_size: '9',
};
exports.sewingNotionsNeedlesMachineFixture = {
    ...exports.sewingNotionsBaseFixture,
    needle_system: '130/705 H',
    needle_size: '90/14',
};
exports.sewingNotionsZippersFixture = {
    ...exports.sewingNotionsBaseFixture,
    zipper_type: 'invisible',
    length: '9 in',
};
/** elastic / ribbon add `width`. */
exports.sewingNotionsWidthFixture = {
    ...exports.sewingNotionsBaseFixture,
    width: '3/4 in',
};
exports.sewingNotionsInterfacingFixture = {
    ...exports.sewingNotionsBaseFixture,
    interfacing_weight: 'lightweight',
};
exports.sewingNotionsStabilizerFixture = {
    ...exports.sewingNotionsBaseFixture,
    stabilizer_type: 'cut_away',
};
exports.sewingNotionsBattingFixture = {
    ...exports.sewingNotionsBaseFixture,
    loft: 'low',
};
// ---------------------------------------------------------------------------
// 3) yarn (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.yarnBaseFixture = {
    model: 'Wool of the Andes',
    weight: '4 - Medium',
    fiber_family: 'wool',
    fiber_content: '100% wool',
    care: 'machine wash cold',
    length_amount: 220,
    length_unit: 'yards',
    skein_weight_amount: 100,
    skein_weight_unit: 'g',
    knitting_gauge: '17 sts / 23 rows = 4 in',
    crochet_gauge: '12 sc / 15 rows = 4 in',
    suggested_needle_size: '5 mm / US 8',
    suggested_hook_size: '5.5 mm / US I-9',
    color: 'teal',
    color_family: 'blue',
    dye_lot: 'A123',
};
// ---------------------------------------------------------------------------
// 4) needles_hooks
// ---------------------------------------------------------------------------
exports.needlesHooksBaseFixture = {
    primary_material: 'metal',
};
exports.needlesHooksKnittingStraightFixture = {
    ...exports.needlesHooksBaseFixture,
    size_mm: '4.00 mm (US 6)',
    length: '10 in',
};
exports.needlesHooksKnittingCircularFixture = {
    ...exports.needlesHooksBaseFixture,
    size_mm: '4.00 mm (US 6)',
    cable_length: '16 in',
};
exports.needlesHooksKnittingDpnFixture = {
    ...exports.needlesHooksBaseFixture,
    size_mm: '4.00 mm (US 6)',
    length: '6 in',
    set_count: 5,
};
exports.needlesHooksKnittingInterchangeableFixture = {
    ...exports.needlesHooksBaseFixture,
    size_mm: '4.00 mm (US 6)',
    cable_length: '24 in',
};
exports.needlesHooksCrochetHooksFixture = {
    ...exports.needlesHooksBaseFixture,
    size_mm: '4.00 mm (G-6)',
};
exports.needlesHooksTunisianHooksFixture = {
    ...exports.needlesHooksBaseFixture,
    size_mm: '4.00 mm (G-6)',
    cable_length: '14 in',
};
// ---------------------------------------------------------------------------
// 5) needle_arts (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.needleArtsBaseFixture = {
    item_type: 'floss',
    size: '14 count',
    color: 'red',
    color_family: 'red',
    color_code: 'DMC 310',
};
// ---------------------------------------------------------------------------
// 6) paper (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.paperBaseFixture = {
    weight: '110lb',
    finish: 'matte',
    size: '12x12',
    color: 'white',
    color_family: 'white',
    print_or_pattern: 'polka dot',
};
// ---------------------------------------------------------------------------
// 7) art_supplies (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.artSuppliesBaseFixture = {
    medium: 'acrylic',
    finish: 'matte',
    surface: 'canvas',
    size: '2 oz',
    color: 'red',
    color_family: 'red',
    color_code: 'Pantone 186C',
};
// ---------------------------------------------------------------------------
// 8) beads
// ---------------------------------------------------------------------------
exports.beadsBaseFixture = {
    primary_material: 'glass',
    finish: 'matte',
    shape: 'round',
    color: 'blue',
    color_family: 'blue',
    size: '6mm',
    hole_size: '1mm',
};
exports.beadsWireFixture = {
    ...exports.beadsBaseFixture,
    gauge: '20',
    temper: 'dead_soft',
};
// ---------------------------------------------------------------------------
// 9) cutting_machines
// ---------------------------------------------------------------------------
exports.cuttingMachinesBaseFixture = {
    item_type: 'adhesive_vinyl',
    size: '12x12',
    color: 'red',
    color_family: 'red',
};
exports.cuttingMachinesVinylHtvFixture = {
    ...exports.cuttingMachinesBaseFixture,
    carrier: 'warm_peel',
};
// ---------------------------------------------------------------------------
// 10) adhesives (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.adhesivesBaseFixture = {
    item_type: 'permanent',
    application: 'paper',
    form: 'liquid',
    size: '4 oz',
};
// ---------------------------------------------------------------------------
// 11) clay_resin (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.clayResinBaseFixture = {
    item_type: 'polymer',
    size: '2 oz',
    color: 'white',
    color_family: 'white',
};
// ---------------------------------------------------------------------------
// 12) wood_diy (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.woodDiyBaseFixture = {
    primary_material: 'pine',
    size: '1x2x8',
    finish: 'unfinished',
};
// ---------------------------------------------------------------------------
// 13) floral_decor (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.floralDecorBaseFixture = {
    item_type: 'artificial',
    size: '12 in stem',
    color: 'green',
    color_family: 'green',
};
// ---------------------------------------------------------------------------
// 14) stuffing_dollmaking (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.stuffingDollmakingBaseFixture = {
    primary_material: 'polyester',
    weight: '12 oz bag',
    density: 'medium',
};
// ---------------------------------------------------------------------------
// 15) kids_crafts (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.kidsCraftsBaseFixture = {
    age_range: '3+',
    size: 'small',
    color: 'multicolor',
    color_family: 'multicolor',
};
// ---------------------------------------------------------------------------
// 16) storage (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.storageBaseFixture = {
    primary_material: 'plastic',
    size: '12x8x4 in',
    capacity: '64 compartments',
};
// ---------------------------------------------------------------------------
// 17) embellishments (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.embellishmentsBaseFixture = {
    primary_material: 'acrylic',
    finish: 'matte',
    size: '4mm',
    color: 'clear',
    color_family: 'clear',
};
// ---------------------------------------------------------------------------
// 18) blanks_bases (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.blanksBasesBaseFixture = {
    blank_type: 'tshirt',
    primary_material: 'cotton',
    size: 'Adult L',
    color: 'white',
    color_family: 'white',
};
// ---------------------------------------------------------------------------
// 19) tools (no subcategory adds fields)
// ---------------------------------------------------------------------------
exports.toolsBaseFixture = {
    primary_material: 'metal',
    size: '8 in',
};
/** Build base-fixture entries for a list of subcategories that add no fields. */
function reuseBase(category, attributes, subcategories) {
    return subcategories.map((subcategory) => ({ category, subcategory, attributes }));
}
exports.MATERIAL_ATTRIBUTE_FIXTURES = [
    // 1) fabric
    { category: 'fabric', attributes: exports.fabricBaseFixture },
    ...reuseBase('fabric', exports.fabricBaseFixture, [
        'quilting_cotton', 'cotton_wovens', 'apparel_knits', 'jersey', 'french_terry',
        'fleece', 'flannel', 'felt', 'denim', 'canvas', 'linen', 'silk', 'satin',
        'velvet', 'chiffon', 'upholstery', 'outdoor',
    ]),
    { category: 'fabric', subcategory: 'leather', attributes: exports.fabricThicknessFixture },
    { category: 'fabric', subcategory: 'faux_leather', attributes: exports.fabricThicknessFixture },
    { category: 'fabric', subcategory: 'vinyl', attributes: exports.fabricThicknessFixture },
    // 2) sewing_notions
    { category: 'sewing_notions', attributes: exports.sewingNotionsBaseFixture },
    { category: 'sewing_notions', subcategory: 'thread', attributes: exports.sewingNotionsThreadFixture },
    { category: 'sewing_notions', subcategory: 'needles_hand', attributes: exports.sewingNotionsNeedlesHandFixture },
    { category: 'sewing_notions', subcategory: 'needles_machine', attributes: exports.sewingNotionsNeedlesMachineFixture },
    { category: 'sewing_notions', subcategory: 'zippers', attributes: exports.sewingNotionsZippersFixture },
    { category: 'sewing_notions', subcategory: 'elastic', attributes: exports.sewingNotionsWidthFixture },
    { category: 'sewing_notions', subcategory: 'ribbon', attributes: exports.sewingNotionsWidthFixture },
    { category: 'sewing_notions', subcategory: 'interfacing', attributes: exports.sewingNotionsInterfacingFixture },
    { category: 'sewing_notions', subcategory: 'stabilizer', attributes: exports.sewingNotionsStabilizerFixture },
    { category: 'sewing_notions', subcategory: 'batting', attributes: exports.sewingNotionsBattingFixture },
    ...reuseBase('sewing_notions', exports.sewingNotionsBaseFixture, [
        'bobbins', 'pins_and_clips', 'buttons', 'snaps', 'hook_and_eye', 'hook_and_loop',
        'bias_tape', 'trim', 'lace', 'grommets', 'rivets', 'buckles', 'd_rings', 'o_rings',
        'cord_and_piping',
    ]),
    // 3) yarn (no subcategory adds fields)
    { category: 'yarn', attributes: exports.yarnBaseFixture },
    ...reuseBase('yarn', exports.yarnBaseFixture, [
        'superwash_wool', 'sock_yarn', 'chenille', 'boucle', 'novelty', 'crochet_thread',
        'macrame_cord', 'rug_yarn', 'tapestry_yarn', 'embroidery_yarn',
    ]),
    // 4) needles_hooks
    { category: 'needles_hooks', attributes: exports.needlesHooksBaseFixture },
    { category: 'needles_hooks', subcategory: 'knitting_straight', attributes: exports.needlesHooksKnittingStraightFixture },
    { category: 'needles_hooks', subcategory: 'knitting_circular', attributes: exports.needlesHooksKnittingCircularFixture },
    { category: 'needles_hooks', subcategory: 'knitting_dpn', attributes: exports.needlesHooksKnittingDpnFixture },
    { category: 'needles_hooks', subcategory: 'knitting_interchangeable', attributes: exports.needlesHooksKnittingInterchangeableFixture },
    { category: 'needles_hooks', subcategory: 'crochet_hooks', attributes: exports.needlesHooksCrochetHooksFixture },
    { category: 'needles_hooks', subcategory: 'tunisian_hooks', attributes: exports.needlesHooksTunisianHooksFixture },
    ...reuseBase('needles_hooks', exports.needlesHooksBaseFixture, [
        'stitch_markers', 'row_counters', 'needle_gauges', 'cables',
    ]),
    // 5) needle_arts (no subcategory adds fields)
    { category: 'needle_arts', attributes: exports.needleArtsBaseFixture },
    ...reuseBase('needle_arts', exports.needleArtsBaseFixture, [
        'embroidery_floss', 'pearl_cotton', 'embroidery_thread', 'aida', 'evenweave',
        'linen_cloth', 'needlepoint_canvas', 'hoops_and_frames', 'stabilizer', 'patterns_and_kits',
    ]),
    // 6) paper (no subcategory adds fields)
    { category: 'paper', attributes: exports.paperBaseFixture },
    ...reuseBase('paper', exports.paperBaseFixture, [
        'cardstock', 'patterned_paper', 'scrapbook_pads', 'vellum', 'tissue_paper', 'envelopes',
        'journals_planners', 'stickers', 'washi_tape', 'stamps', 'ink_pads', 'embossing',
        'dies', 'die_cuts', 'ephemera',
    ]),
    // 7) art_supplies (no subcategory adds fields)
    { category: 'art_supplies', attributes: exports.artSuppliesBaseFixture },
    ...reuseBase('art_supplies', exports.artSuppliesBaseFixture, [
        'paint_acrylic', 'paint_watercolor', 'paint_gouache', 'paint_oil', 'paint_fabric',
        'paint_spray', 'ink_alcohol', 'ink_india', 'markers', 'pens', 'colored_pencils',
        'graphite_charcoal', 'pastels', 'brushes', 'canvas_panels', 'sketchbooks_paper', 'mediums',
    ]),
    // 8) beads
    { category: 'beads', attributes: exports.beadsBaseFixture },
    { category: 'beads', subcategory: 'wire', attributes: exports.beadsWireFixture },
    ...reuseBase('beads', exports.beadsBaseFixture, [
        'seed_beads', 'glass_beads', 'gemstone_beads', 'metal_beads', 'findings', 'jump_rings',
        'clasps', 'ear_wires', 'headpins', 'chain', 'cord', 'elastic_cord', 'leather_cord', 'crimp_beads',
    ]),
    // 9) cutting_machines
    { category: 'cutting_machines', attributes: exports.cuttingMachinesBaseFixture },
    { category: 'cutting_machines', subcategory: 'vinyl_htv', attributes: exports.cuttingMachinesVinylHtvFixture },
    ...reuseBase('cutting_machines', exports.cuttingMachinesBaseFixture, [
        'vinyl_adhesive', 'vinyl_specialty', 'transfer_tape', 'weeding_tools', 'cutting_mats',
        'blades', 'pens', 'foil_transfer', 'smart_materials', 'machine_accessories',
    ]),
    // 10) adhesives (no subcategory adds fields)
    { category: 'adhesives', attributes: exports.adhesivesBaseFixture },
    ...reuseBase('adhesives', exports.adhesivesBaseFixture, [
        'glue_stick', 'pva_glue', 'tacky_glue', 'super_glue', 'fabric_glue', 'spray_adhesive',
        'hot_glue_sticks', 'double_sided_tape', 'masking_tape', 'painter_tape', 'mod_podge',
        'varnish', 'sealant',
    ]),
    // 11) clay_resin (no subcategory adds fields)
    { category: 'clay_resin', attributes: exports.clayResinBaseFixture },
    ...reuseBase('clay_resin', exports.clayResinBaseFixture, [
        'polymer_clay', 'air_dry_clay', 'ceramic_clay', 'epoxy_resin', 'uv_resin', 'molds',
        'pigments', 'mica_powder', 'inclusions', 'sculpting_tools', 'armature_wire', 'glaze', 'sealant',
    ]),
    // 12) wood_diy (no subcategory adds fields)
    { category: 'wood_diy', attributes: exports.woodDiyBaseFixture },
    ...reuseBase('wood_diy', exports.woodDiyBaseFixture, [
        'wood_blanks', 'unfinished_wood', 'dowels', 'craft_sticks', 'stencils', 'hardware_small',
        'picture_hangers', 'mosaic_tiles',
    ]),
    // 13) floral_decor (no subcategory adds fields)
    { category: 'floral_decor', attributes: exports.floralDecorBaseFixture },
    ...reuseBase('floral_decor', exports.floralDecorBaseFixture, [
        'artificial_flowers', 'floral_stems', 'greenery', 'wreath_forms', 'floral_foam',
        'floral_wire', 'floral_tape', 'picks_sprays', 'ornaments', 'seasonal_decor',
    ]),
    // 14) stuffing_dollmaking (no subcategory adds fields)
    { category: 'stuffing_dollmaking', attributes: exports.stuffingDollmakingBaseFixture },
    ...reuseBase('stuffing_dollmaking', exports.stuffingDollmakingBaseFixture, [
        'polyfill', 'batting', 'foam', 'pellets', 'pillow_forms', 'safety_eyes', 'safety_noses',
        'doll_joints', 'armature',
    ]),
    // 15) kids_crafts (no subcategory adds fields)
    { category: 'kids_crafts', attributes: exports.kidsCraftsBaseFixture },
    ...reuseBase('kids_crafts', exports.kidsCraftsBaseFixture, [
        'pom_poms', 'googly_eyes', 'pipe_cleaners', 'foam_sheets', 'craft_sticks',
        'washable_paint', 'glitter', 'beads_kids', 'safety_scissors',
    ]),
    // 16) storage (no subcategory adds fields)
    { category: 'storage', attributes: exports.storageBaseFixture },
    ...reuseBase('storage', exports.storageBaseFixture, [
        'bins', 'totes', 'jars', 'drawers', 'dividers', 'bobbin_boxes', 'project_bags',
        'label_maker', 'organizers',
    ]),
    // 17) embellishments (no subcategory adds fields)
    { category: 'embellishments', attributes: exports.embellishmentsBaseFixture },
    ...reuseBase('embellishments', exports.embellishmentsBaseFixture, [
        'rhinestones', 'sequins', 'patches', 'applique', 'charms',
    ]),
    // 18) blanks_bases (no subcategory adds fields)
    { category: 'blanks_bases', attributes: exports.blanksBasesBaseFixture },
    ...reuseBase('blanks_bases', exports.blanksBasesBaseFixture, [
        'tshirts', 'totes', 'hats', 'mugs', 'tumblers', 'pillow_covers', 'signs',
        'ornaments_blanks', 'canvas_blank',
    ]),
    // 19) tools (no subcategory adds fields)
    { category: 'tools', attributes: exports.toolsBaseFixture },
    ...reuseBase('tools', exports.toolsBaseFixture, [
        'scissors_shears', 'rotary_cutter', 'cutting_mat', 'craft_knife', 'replacement_blades',
        'rulers', 'tape_measure', 'french_curve', 'seam_ripper', 'awl', 'punches', 'pliers',
        'wire_cutters', 'glue_gun', 'heat_tool', 'marking_tools',
    ]),
];
